import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Instagram, Facebook, Youtube } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function Footer() {
  const { settings } = useSite();
  const s = settings || {};

  return (
    <footer className="bg-[#084C3A] text-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <img
                src="https://ik.imagekit.io/sekawan/KBIH/logo%20KBIHsby.png"
                alt="KBIHU Muhammadiyah Surabaya"
                className="h-11 w-11 shrink-0 object-contain"
              />
              <div className="leading-tight">
                <span className="block font-heading text-sm font-bold uppercase tracking-tight">KBIHU Muhammadiyah</span>
                <span className="block font-heading text-xs font-semibold uppercase tracking-wide text-white/80">Surabaya</span>
              </div>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-white/70">
              {s.description || "Lembaga bimbingan ibadah Haji dan Umrah yang mendampingi jamaah dengan ilmu, bimbingan, dan ketulusan."}
            </p>
            <div className="mt-5 flex gap-3">
              {s.social_links?.instagram && (
                <a href={s.social_links.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-white/20">
                  <Instagram className="h-4 w-4" />
                </a>
              )}
              {s.social_links?.facebook && (
                <a href={s.social_links.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-white/20">
                  <Facebook className="h-4 w-4" />
                </a>
              )}
              {s.social_links?.youtube && (
                <a href={s.social_links.youtube} target="_blank" rel="noreferrer" data-testid="footer-youtube" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-white/20">
                  <Youtube className="h-4 w-4" />
                </a>
              )}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wide text-white/90">Navigasi</h4>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              <li><Link to="/tentang-kami" className="hover:text-white">Tentang Kami</Link></li>
              <li><Link to="/program" className="hover:text-white">Program</Link></li>
              <li><Link to="/pembimbing" className="hover:text-white">Pembimbing</Link></li>
              <li><Link to="/manasik" className="hover:text-white">Jadwal Manasik</Link></li>
              <li><Link to="/artikel" className="hover:text-white">Artikel</Link></li>
              <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wide text-white/90">Kontak</h4>
            <ul className="mt-4 space-y-3 text-sm text-white/70">
              <li className="flex gap-2"><MapPin className="h-4 w-4 shrink-0 mt-0.5" /> {s.address}</li>
              <li className="flex gap-2"><Phone className="h-4 w-4 shrink-0 mt-0.5" /> {s.phone}</li>
              <li className="flex gap-2"><Mail className="h-4 w-4 shrink-0 mt-0.5" /> {s.email}</li>
              <li className="flex gap-2"><Clock className="h-4 w-4 shrink-0 mt-0.5" /> {s.service_hours || "Senin - Sabtu, 08.00 - 17.00 WIB"}</li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wide text-white/90">Lokasi</h4>
            <a
              href={s.maps_url}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-maps-link"
              className="mt-4 block overflow-hidden rounded-xl border border-white/10"
            >
              <div className="flex h-32 items-center justify-center bg-white/5 text-sm text-white/60">
                <MapPin className="mr-2 h-4 w-4" /> Lihat di Google Maps
              </div>
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-6 text-xs text-white/50 sm:flex-row">
          <p>&copy; {new Date().getFullYear()} KBIHU Muhammadiyah Surabaya. Seluruh hak cipta dilindungi.</p>
          <div className="flex gap-4">
            <Link to="/kebijakan-privasi" className="hover:text-white">Kebijakan Privasi</Link>
            <Link to="/syarat-ketentuan" className="hover:text-white">Syarat &amp; Ketentuan</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
